import Add from './Add.tsx';
import AiAssistant from './AiAssistant.tsx';
import Analytics from './Analytics.tsx';
import Archived from './Archived.tsx';
import Bell from './Bell.tsx';
import Booked from './Booked.tsx';
import Calendar from './Calendar.tsx';
import Cancel from './Cancel.tsx';
import Chart from './Chart.tsx';
import Check from './Check.tsx';
import Clear from './Clear.tsx';
import Clock from './Clock.tsx';
import Company from './Company.tsx';
import Dashboard from './Dashboard.tsx';
import Database from './Database.tsx';
import Display from './Display.tsx';
import Document from './Document.tsx';
import Dollar from './Dollar.tsx';
import Draft from './Draft.tsx';
import Edit from './Edit.tsx';
import FastTranslate from './FastTranslate.tsx';
import Fire from './Fire.tsx';
import Gear from './Gear.tsx';
import Headphones from './Headphones.tsx';
import Hint from './Hint.tsx';
import HorizontalLayout from './HorizontalLayout.tsx';
import Image from './Image.tsx';
import Info from './Info.tsx';
import InProgress from './InProgress.tsx';
import Megaphone from './Megaphone.tsx';
import MouseCursor from './MouseCursor.tsx';
import Newspaper from './Newspaper.tsx';
import Offered from './Offered.tsx';
import Pause from './Pause.tsx';
import Payout from './Payout.tsx';
import Percentage from './Percentage.tsx';
import Person from './Person.tsx';
import PersonAdd from './PersonAdd.tsx';
import PersonRemove from './PersonRemove.tsx';
import Phone from './Phone.tsx';
import Photo from './Photo.tsx';
import Play from './Play.tsx';
import PlayAlt from './PlayAlt.tsx';
import Preview from './Preview.tsx';
import PreviewCrossed from './PreviewCrossed.tsx';
import Rectangle from './Rectangle.tsx';
import Remove from './Remove.tsx';
import Revenue from './Revenue.tsx';
import Rise from './Rise.tsx';
import SettingsAlt from './SettingsAlt.tsx';
import Square from './Square.tsx';
import Tag from './Tag.tsx';
import Targeting from './Targeting.tsx';
import TemporaryUnavailable from './TemporaryUnavailable.tsx';
import Users from './Users.tsx';
import Warning from './Warning.tsx';

export const FilledIcons = {
  Add,
  AiAssistant,
  Analytics,
  Archived,
  Bell,
  Booked,
  Calendar,
  Cancel,
  Chart,
  Check,
  Clear,
  Clock,
  Company,
  Dashboard,
  Database,
  Display,
  Document,
  Dollar,
  Draft,
  Edit,
  FastTranslate,
  Gear,
  Headphones,
  Hint,
  HorizontalLayout,
  Info,
  Image,
  InProgress,
  Megaphone,
  MouseCursor,
  Newspaper,
  Offered,
  Pause,
  Payout,
  Percentage,
  Person,
  PersonAdd,
  PersonRemove,
  Phone,
  Photo,
  Play,
  PlayAlt,
  Preview,
  PreviewCrossed,
  Rectangle,
  Remove,
  Revenue,
  Rise,
  SettingsAlt,
  Fire,
  Square,
  Tag,
  Targeting,
  TemporaryUnavailable,
  Users,
  Warning,
};

export default FilledIcons;
